import { FeatureCollection } from "geojson";
import { LifeCycleStage } from "./LifeCycleStage";
import { Score } from "@keita/lanepatrol-sdk";
import { PhotoSource } from "./OsaNode";

export interface OsaWay {
  id: string;
  campaignId: string;
  name: string;
  uploadFinished: boolean;
  photoSource: PhotoSource;
  lifeCycleStage: LifeCycleStage;
  geoJson: FeatureCollection | null;
  score: Score | null;
  stats: OsaWayStats | null;
  permissions: OsaWayPermissions;
    description: string | null;
    plannedTrajectory: FeatureCollection | null;
    plannedDistance : number;
  dateTime: string;
  createdAt: string;
}

export interface OsaWayStats {
  nNodes: number;
  nNodesCoded: number;
  nActiveComments: number | null;
  totalDistance: number;
}

export interface DeviceOutputLinksResponse {
  outputs: string;
  pictures: string;
}

export interface GpxUploadLinksResponse {
  gpx: string;
  pictures: string;
}

export interface UploadLinksRequest {
  inputType: UploadInputType;
}

export enum UploadInputType {
  DeviceOutput = "DeviceOutput",
  Gpx = "Gpx",
}

export interface CreateOsaWay {
  campaignId: string;
  name: string;
}

export interface UpdateOsaWay {
  name: string;
  description: string;
  plannedTrajectory: FeatureCollection | null;
  plannedDistance: number;
}

export interface OsaWayPermissions {
  canRead: boolean;
  canCreate: boolean;
  canUpdate: boolean;
  canDelete: boolean;
  canCode: boolean;
  canComment: boolean;
  canReview: boolean;
  canManage: boolean;
  canUpdateLifeCycleStage: boolean;
  canRevertLifeCycleStage: boolean;
}
